import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output
} from '@angular/core';

import type { Metric } from './m-metric-card.component.types';
import { MCardComponent } from '../../../components/m-card/m-card.component';
import { MTagComponent } from '../../../components/m-tag/m-tag.component';
import { MTypePillComponent } from '../../../components/m-type-pill/m-type-pill.component';
import { PercentPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-metric-card',
  templateUrl: './m-metric-card.component.html',
  imports: [MCardComponent, MTagComponent, MTypePillComponent, PercentPipe]
})
export class MMetricCardComponent {
  @Input() metric!: Metric;
  readonly cardClick = output<Metric>();

  onClick(): void {
    this.cardClick.emit(this.metric);
  }
}
